import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["parameters"];
export const SHARED_CHANGE_TONE_SUBMENU_OPTIONS = [{
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.friendly',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.friendly',
  customIntent: 'content_rewrite',
  parameters: {
    toneOfVoice: 'friendly',
    promptThread: 'copilotCollaboration.command.tones.friendly.promptThread',
    operation: 'Rewrite the selected text to have a friendly tone'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.professional',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.professional',
  customIntent: 'content_rewrite',
  parameters: {
    toneOfVoice: 'professional',
    promptThread: 'copilotCollaboration.command.tones.professional.promptThread',
    operation: 'Rewrite the selected text to have a professional tone'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.witty',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.witty',
  customIntent: 'content_rewrite',
  parameters: {
    toneOfVoice: 'witty',
    promptThread: 'copilotCollaboration.command.tones.witty.promptThread',
    operation: 'Rewrite the selected text to have a witty tone'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.heartfelt',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.heartfelt',
  customIntent: 'content_rewrite',
  parameters: {
    toneOfVoice: 'heartfelt',
    promptThread: 'copilotCollaboration.command.tones.heartfelt.promptThread',
    operation: 'Rewrite the selected text to have a heartfelt tone'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.educational',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.educational',
  customIntent: 'content_rewrite',
  parameters: {
    toneOfVoice: 'educational',
    promptThread: 'copilotCollaboration.command.tones.educational.promptThread',
    operation: 'Rewrite the selected text to have an educational tone'
  }
}];
const generateSharedSubMenuForCopilot = ({
  // E.g."In a ${toneOfVoice} way, rewrite selected text"
  getPrefixString,
  getPromptThread
}) => {
  return SHARED_CHANGE_TONE_SUBMENU_OPTIONS.map(_ref => {
    let {
        parameters
      } = _ref,
      option = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, option, {
      parameters: {
        toneOfVoice: parameters.toneOfVoice,
        promptThread: (getPromptThread === null || getPromptThread === void 0 ? void 0 : getPromptThread(parameters.toneOfVoice)) || parameters.promptThread,
        operation: getPrefixString(parameters.toneOfVoice)
      }
    });
  });
};
export const BRAND_VOICE_CONTENT_TYPES = {
  CASE_STUDY: 'case study',
  LANDING_PAGE: 'landing page',
  SITE_PAGE: 'site page',
  BLOG_POST: 'blog post',
  MARKETING_EMAIL: 'marketing email',
  MARKETING_SMS: 'marketing sms message',
  SOCIAL_POST: 'social post'
};

// Serves as a library of commands that consumer apps pick from when configuring
// the selection command component.
export const SELECTION_COMMANDS = {
  // Blog specific
  BLOG_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'blog_inline_selection_commands_rewrite_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      operation: 'Rewrite selected text'
    }
  },
  BLOG_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'blog_inline_selection_commands_expand_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: 'Expand on the selected text'
    }
  },
  BLOG_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'blog_inline_selection_commands_shorten_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: 'Shorten the selected text'
    }
  },
  BLOG_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'blog_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  BLOG_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.BLOG_POST,
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'Apply brand identity or brand voice to the selected text'
    }
  },
  // TODO look at this, copy, etc...
  BLOG_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'blog_ask_for_more_options_v1',
    // Passing to contentAssistantUtils..getInitialPromptData (via tinyMCE)
    // see: https://git.hubteam.com/HubSpot/copilot-toolkit/blob/09af94057c6e5a64f927e618de067ea4083f47ee/copilot-plugins/static/js/utils/contentAssistantUtils.ts#L128
    parameters: {
      // its this or have it be "true" (as string)
      // Its hacky, but its safe.
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.blog.promptThread'
    }
  },
  // CTA specific
  CTA_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'cta_inline_selection_commands_rewrite_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      operation: `You are an expert content marketer specializing in high-converting
        website copy. Please rewrite the selected text to make it clearer, smoother, and
        more engaging while keeping the original meaning intact. Maintain all existing
        formatting (line breaks, bullet points, bold text, etc.). When rephrasing,
        prioritize clarity and flow while making sure the message remains actionable and
        relevant to a website visitor.
        Example:
        "Click here to learn more." could become
        "Discover all the details - click to explore."`
    }
  },
  CTA_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'cta_inline_selection_commands_expand_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: `You are an expert content marketer with deep knowledge
        of website calls-to-action (CTAs). Expand the selected text by adding useful
        context, benefits, and persuasive details to make the message more compelling for
        a website visitor. Keep existing formatting intact. Focus on driving engagement
        and explaining why the visitor should care.
        Example:
        "Sign up for our newsletter." could become
        "Stay ahead with expert insights, tips, and special offers - sign up for our newsletter today!"`
    }
  },
  CTA_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'cta_inline_selection_commands_shorten_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: `You are an expert content marketer skilled at distilling long
        copy into impactful, punchy calls-to-action (CTAs). Summarize the selected text
        into a clear, concise message that still conveys the core value. Maintain
        existing formatting and aim for a length that fits well in a CTA button or
        banner.
        Example:
        "Our award-winning software helps businesses automate their sales processes,
        save time, and close more deals — all with an easy-to-use interface." could become
        "Save time and close more deals with award-winning sales automation."`
    }
  },
  CTA_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'cta_inline_selection_commands_change_tone_v1',
    subMenu: generateSharedSubMenuForCopilot({
      getPrefixString: toneOfVoice => {
        const knownPrompt = {
          friendly: `You are an expert content marketer writing for a
            friendly, approachable brand. Rewrite the selected text with a friendly,
            conversational tone - as if you're talking to a helpful colleague or a
            trusted advisor. Keep all existing formatting intact.
            Example:
            "Download the report." could become
            "Want a closer look? Grab your free copy of the report!"`,
          professional: `You are an expert content marketer writing for a
            professional, B2B audience. Rewrite the selected text to sound polished,
            clear, and credible - while keeping existing formatting intact. Focus on
            using direct, confident language that inspires trust.
            Example:
            "Get started today." could become
            "Start your free trial and experience the difference firsthand."`,
          witty: `You are an expert content marketer known for writing
            witty, clever website copy that grabs attention. Rewrite the selected text
            with a playful, creative twist - but keep the message clear and the
            formatting intact. Use humor or wordplay if it fits.
            Example:
            "Subscribe to our newsletter." could become
            "Join the club - we'll send smart stuff your way."`,
          heartfelt: `You are an expert content marketer writing for a
            brand that values authenticity and emotional connection. Rewrite the selected
            text to feel heartfelt, sincere, and human - while keeping existing
            formatting intact. Focus on creating an emotional pull or sense of belonging.
            Example:
            "Donate today." could become
            "Your support means the world - donate today to make a difference."`,
          educational: `You are an expert content marketer writing for a
            knowledge-driven audience. Rewrite the selected text to sound educational and
            informative - as if you're teaching the reader something useful. Keep
            existing formatting intact, and prioritize clarity.
            Example:
            "Learn more." could become
            "Explore how this solution works and why it matters."`
        }[toneOfVoice];
        return knownPrompt !== null && knownPrompt !== void 0 ? knownPrompt : `Rewrite this call-to-action text in a ${toneOfVoice} tone of voice. Make it feel natural and engaging.`;
      },
      getPromptThread: toneOfVoice => `baseContentGenerationModal.inlineToolbar.options.more.social.changeTone.${toneOfVoice}.promptThread`
    })
  },
  CTA_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'cta_ask_for_more_options_v1',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.cta.promptThread'
    }
  },
  // Pages specific
  PAGES_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the selected text using the brand voice of the company. The selected text should be rewritten to update the tone but the message should carry through.'
    }
  },
  PAGES_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'page_inline_selection_commands_rewrite_v1'
  },
  PAGES_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'page_inline_selection_commands_expand_v1'
  },
  PAGES_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'page_inline_selection_commands_shorten_v1'
  },
  // These are just for the pages app because they use brand voice and BV is not
  // yet supported in the other apps using PAGES_REPHRASE, PAGES_EXPAND_IDEA,
  // and PAGES_SUMMARIZE_IDEA (i.e. GCE, Forms, web interactives)
  PAGES_REPHRASE_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_rewrite_v2',
    customIntent: 'content_rewrite',
    parameters: {
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      operation: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the selected text so that it is simple and clear to understand as a visitor on the page. The rewritten text should align with the brand identity or brand voice, be grammatically correct, and should maintain the original message.'
    }
  },
  PAGES_EXPAND_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_expand_v2',
    customIntent: 'content_rewrite',
    parameters: {
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Expand and build upon the message of the selected text. Maintain the same brand voice and ensure that the text is grammatically correct, uses simple language, and sounds compelling.'
    }
  },
  PAGES_SUMMARIZE_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_shorten_v2',
    customIntent: 'content_rewrite',
    parameters: {
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Summarize the message of the selected text. Ensure that the summary is grammatically correct, uses simple language, and concise. It should maintain the core message and be easy to understand as the reader.'
    }
  },
  PAGES_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'page_inline_selection_commands_change_tone_v1',
    subMenu: generateSharedSubMenuForCopilot({
      getPrefixString: toneOfVoice => {
        switch (toneOfVoice) {
          case 'friendly':
            return 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the selected text to have a friendly tone. Ensure that the updated text is grammatically correct, uses simple language, and is concise. It should maintain the core message and be easy to understand as the reader.';
          case 'professional':
            return 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the text to sound more professional and formal, that adheres to business communication standards. Focus on refining the text for conciseness and for a knowledgable tone. Avoid colloquialisms and jargon. Ensure that the updated text is grammatically correct and maintains the core message.';
          case 'witty':
            return 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the text to sound more witty and engaging, while still being helpful. Ensure that the updated text is grammatically correct and maintains the core message. Remember that this content lives on a web page.';
          case 'heartfelt':
            return 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the text to evoke genuine emotion and warmth, while still being helpful. It should be sincere and touching. Ensure that the updated text is grammatically correct and maintains the core message. Remember that this content lives on a web page.';
          case 'educational':
            return 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite the text in a more structured and educational manner. Help break down complex concepts into simpler more educational terms. Ensure that the updated text is grammatically correct and maintains the core message. Remember that this content lives on a web page.';
          default:
            return `You are an expert content marketer with experience creating high performing and conversion optimized web pages. Rewrite this text in a ${toneOfVoice} tone of voice. Make it feel natural and engaging. Ensure that the updated text is grammatically correct and maintains the core message. Remember that this content lives on a web page.'`;
        }
      }
    })
  },
  // TODO look at this, copy, etc...
  PAGES_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'pages_ask_for_more_options_v1',
    // Passing to contentAssistantUtils..getInitialPromptData (via tinyMCE)
    // see: https://git.hubteam.com/HubSpot/copilot-toolkit/blob/09af94057c6e5a64f927e618de067ea4083f47ee/copilot-plugins/static/js/utils/contentAssistantUtils.ts#L128
    parameters: {
      // its this or have it be "true" (as string)
      // Its hacky, but its safe.
      promptForMoreInfo: true,
      promptPrefix: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. The content you write should be grammatically correct and maintain the core message. Remember that this content lives on a web page. Rewrite the text based on the following:',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.pages.promptThread'
    }
  },
  // Marketing email specific
  MARKETING_EMAIL_REPHRASE_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_rewrite_v2',
    parameters: {
      voiceChannel: 'EMAIL',
      operation: 'You are an expert marketer composing a marketing email. Use your expert writing skills to rewrite the fragment in a unique and captivating way',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.email.rewrite.promptThread'
    }
  },
  MARKETING_EMAIL_REPHRASE_V3: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_rewrite_v2',
    parameters: {
      voiceChannel: 'EMAIL',
      operation: 'You are an expert marketer composing a marketing email. Use your expert writing skills to rewrite the fragment in a unique and captivating way',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.email.rewrite.promptThread'
    }
  },
  MARKETING_EMAIL_EXPAND_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_expand_v2',
    parameters: {
      voiceChannel: 'EMAIL',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.email.expand.promptThread',
      operation: 'You are an expert marketer composing a marketing email. Use your expert writing skills to expand the fragment in a unique and captivating way'
    }
  },
  MARKETING_EMAIL_SUMMARIZE_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_shorten_v2',
    parameters: {
      voiceChannel: 'EMAIL',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.email.shorten.promptThread',
      operation: 'You are an expert marketer composing a marketing email. Use your expert writing skills to write the fragment in a concise form'
    }
  },
  MARKETING_EMAIL_CHANGE_TONE_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'marketing_email_inline_selection_commands_change_tone_v2',
    subMenu: generateSharedSubMenuForCopilot({
      getPrefixString: toneOfVoice => `Rewrite this email fragment in a ${toneOfVoice} tone of voice. Make it feel natural and engaging.`,
      getPromptThread: toneOfVoice => `baseContentGenerationModal.inlineToolbar.options.more.social.changeTone.${toneOfVoice}.promptThread`
    })
  },
  MARKETING_EMAIL_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.MARKETING_EMAIL,
      voiceChannel: 'EMAIL',
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'Apply brand identity or brand voice to the selected text'
    }
  },
  // TODO look at this, copy, etc...
  MARKETING_EMAIL_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'ask_for_more_options_v1',
    // Passing to contentAssistantUtils..getInitialPromptData (via tinyMCE)
    // see: https://git.hubteam.com/HubSpot/copilot-toolkit/blob/09af94057c6e5a64f927e618de067ea4083f47ee/copilot-plugins/static/js/utils/contentAssistantUtils.ts#L128
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.email.more.promptThread'
    }
  },
  // SMS specific
  SMS_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_rewrite_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      voiceChannel: 'SMS',
      operation: `You are an expert marketer composing a marketing SMS message. Use your expert writing skills to rewrite the SMS in a unique and captivating way,
      following this instructions:
        1. Ensure that it fits cohesively and coherently in the original SMS text.
        2. If the fragment is using emojis or personalisation tokens, include them.
        3. The rewritten text fragment should be under 140 characters
      Taking all of the above into consideration, rewrite the SMS message:`
    }
  },
  SMS_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_expand_v1',
    parameters: {
      voiceChannel: 'SMS',
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: 'You are an expert marketer composing a marketing SMS message. Use your expert writing skills to expand the selected text in a unique and captivating way, and ensure that it fits cohesively and coherently in the original SMS text keeping the content under 140 characters.'
    }
  },
  SMS_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_shorten_v1',
    parameters: {
      voiceChannel: 'SMS',
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: 'Shorten the selected text to make it more concise and ensure that it fits cohesively and coherently in the original SMS text'
    }
  },
  SMS_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'sms_inline_selection_commands_change_tone_v1',
    subMenu: generateSharedSubMenuForCopilot({
      getPrefixString: toneOfVoice => `Rewrite the SMS message in a ${toneOfVoice} tone of voice.  Make it feel natural and engaging and ensure that it fits cohesively and coherently in the original sms text`,
      getPromptThread: toneOfVoice => `baseContentGenerationModal.inlineToolbar.options.more.social.changeTone.${toneOfVoice}.promptThread`
    })
  },
  SMS_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.MARKETING_SMS,
      voiceChannel: 'SMS',
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'Apply brand identity or brand voice to the selected text'
    }
  },
  SMS_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'ask_for_more_options_v1',
    parameters: {
      // its this or have it be "true" (as string)
      // Its hacky, but its safe.
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.sms.promptThread'
    }
  },
  // KB specific
  KB_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'kb_inline_selection_commands_rewrite_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      operation: 'Rewrite selected text'
    }
  },
  KB_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'kb_inline_selection_commands_expand_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: 'Expand on the selected text'
    }
  },
  KB_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'kb_inline_selection_commands_shorten_v1',
    parameters: {
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: 'Shorten the selected text'
    }
  },
  KB_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'kb_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  KB_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'ask_for_more_options_v1',
    parameters: {
      // its this or have it be "true" (as string)
      // Its hacky, but its safe.
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.kb.promptThread'
    }
  },
  FIX_GRAMMAR: {
    commandId: 'inline_selection_commands_fix_grammar_v1',
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.fixGrammar',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.fixGrammar'
  },
  // Case Study specific
  CASE_STUDY_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'case_study_inline_selection_commands_rewrite_v1',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'CASE_STUDIES',
      promptThread: 'copilotCollaboration.command.rephrase.promptThread',
      operation: 'Rewrite selected text'
    }
  },
  CASE_STUDY_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'case_study_inline_selection_commands_expand_v1',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'CASE_STUDIES',
      promptThread: 'copilotCollaboration.command.expand.promptThread',
      operation: 'Expand on the selected text'
    }
  },
  CASE_STUDY_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'case_study_inline_selection_commands_shorten_v1',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'CASE_STUDIES',
      promptThread: 'copilotCollaboration.command.shorten.promptThread',
      operation: 'Shorten the selected text'
    }
  },
  CASE_STUDY_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'case_study_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  CASE_STUDY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.CASE_STUDY,
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'Apply brand identity or brand voice to the selected text'
    }
  },
  CASE_STUDY_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'ask_for_more_options_v1',
    // Passing to contentAssistantUtils..getInitialPromptData (via tinyMCE)
    // see: https://git.hubteam.com/HubSpot/copilot-toolkit/blob/09af94057c6e5a64f927e618de067ea4083f47ee/copilot-plugins/static/js/utils/contentAssistantUtils.ts#L128
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.caseStudy.promptThread'
    }
  },
  //SOCIAL
  SOCIAL_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.SOCIAL_POST,
      voiceChannel: 'SOCIAL',
      promptThread: 'copilotCollaboration.command.brandVoice.promptThread',
      operation: 'You are an expert social media manager crafting engaging and on-brand social media content for a post. Your goal is to refine the given text to match the brand’s unique voice, maintaining consistency and appeal. Ensure the tone aligns with the brand’s identity—while keeping the message concise, engaging, and platform-appropriate. Use the best practices of the platform to enhance the message. Preserve key messaging while improving clarity, flow, and impact. The post should feel natural and resonate with the target audience.'
    }
  },
  SOCIAL_REWRITE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'social_rephrase_v1',
    parameters: {
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.social.rewrite.promptThread',
      operation: 'You are an expert social media manager crafting engaging content for an SMB’s social media post. Rewrite the following post to make it more engaging, natural, and attention-grabbing while maintaining clarity and authenticity. Ensure it aligns with best practices for platform engagement (e.g., hooks, strong CTAs, conversational tone). Keep it concise but compelling, and adapt for LinkedIn, X, Instagram, or Facebook as needed'
    }
  },
  SOCIAL_EXPAND: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'social_expand_v1',
    parameters: {
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.social.expand.promptThread',
      operation: 'You are an expert social media manager expanding a social media post to provide more context and depth while keeping it engaging and digestible. Add relevant details, storytelling elements, or supporting information without making it feel bloated. If applicable, include audience-friendly analogies, statistics, or relatable examples to enhance engagement. Maintain a tone appropriate for social media platforms such as LinkedIn, X, Instagram, or Facebook.'
    }
  },
  SOCIAL_SHORTEN: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'social_shorten_v1',
    parameters: {
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.social.shorten.promptThread',
      operation: 'You are an expert social media manager refining a social media post to be more concise while retaining its key message and engagement factor. Remove redundancy, simplify complex ideas, and ensure the post remains compelling. Keep it within optimal character limits for the social media network if specified. Maintain readability and impact'
    }
  },
  SOCIAL_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'social_post_change_tone_v1',
    subMenu: generateSharedSubMenuForCopilot({
      getPrefixString: toneOfVoice => {
        switch (toneOfVoice) {
          case 'friendly':
            return 'You are an expert social media manager rewriting a post in a friendly and approachable tone. Make it feel warm, inviting, and conversational while ensuring it stays engaging and natural. Use inclusive language and an easygoing style that resonates with a broad audience.';
          case 'professional':
            return 'You are an expert social media manager rewriting a post in a polished, professional tone. Ensure clarity, credibility, and a confident voice while keeping it engaging and approachable. Avoid jargon overload, and structure the message in a way that resonates with professionals on social media';
          case 'witty':
            return "You are an expert social media manager rewriting a post with a witty and clever tone. Infuse humor, wordplay, or a fun twist while keeping it engaging and natural. Ensure it aligns with the brand's voice and resonates with audiences on social media networks like LinkedIn, X, Instagram, or Facebook without feeling forced or over-the-top";
          case 'heartfelt':
            return 'You are an expert social media manager rewriting a post with a heartfelt and emotionally resonant tone. Make it genuine, warm, and personal, evoking emotion without feeling overly dramatic. Use storytelling techniques or personal anecdotes if relevant. Ensure it resonates on the social media network if specified.';
          case 'educational':
            return 'You are an expert social media manager rewriting a post in an educational and informative tone. Make it clear, insightful, and value-driven while keeping it engaging and digestible. Use straightforward explanations, practical takeaways, and if relevant, examples or step-by-step guidance. Ensure it remains platform-appropriate for the social media network if specified';
          default:
            return `Rewrite this social media post in a ${toneOfVoice} tone of voice. Make it feel natural and engaging.`;
        }
      },
      getPromptThread: toneOfVoice => `baseContentGenerationModal.inlineToolbar.options.more.social.changeTone.${toneOfVoice}.promptThread`
    })
  },
  SOCIAL_MORE_OPTION: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.more.label',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_ask_for_more_options_v1',
    // Passing to contentAssistantUtils..getInitialPromptData (via tinyMCE)
    // see: https://git.hubteam.com/HubSpot/copilot-toolkit/blob/09af94057c6e5a64f927e618de067ea4083f47ee/copilot-plugins/static/js/utils/contentAssistantUtils.ts#L128
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: 'Rewrite selected text based on the following: ',
      promptThread: 'baseContentGenerationModal.inlineToolbar.options.more.social.more.promptThread'
    }
  }
};

// App-specific configs
export const BLOG_SELECTION_COMMANDS = [SELECTION_COMMANDS.BLOG_REPHRASE, SELECTION_COMMANDS.BLOG_EXPAND_IDEA, SELECTION_COMMANDS.BLOG_SUMMARIZE_IDEA, SELECTION_COMMANDS.BLOG_CHANGE_TONE];
export const BLOG_SELECTION_COMMANDS_WITH_ENABLED_BRAND_VOICE = [SELECTION_COMMANDS.BLOG_BRAND_VOICE, ...BLOG_SELECTION_COMMANDS];
export const BLOG_SELECTION_COMMANDS_WITH_DISABLED_BRAND_VOICE = [Object.assign({}, SELECTION_COMMANDS.BLOG_BRAND_VOICE, {
  disabled: true
}), ...BLOG_SELECTION_COMMANDS];
export const APPLY_BRAND_VOICE_V2 = 'inline_selection_commands_apply_brand_voice_v2';